export default "__VITE_ASSET__BgQtUrnB__"